document.querySelectorAll('[data-countdown]').forEach((timer) => {
  const fields = {
    days: timer.querySelector('[data-cd="days"]'),
    hours: timer.querySelector('[data-cd="hours"]'),
    minutes: timer.querySelector('[data-cd="minutes"]'),
    seconds: timer.querySelector('[data-cd="seconds"]'),
  };

  // A real deadline set in the theme editor, otherwise the end of today.
  // Never a per-visitor timer that silently restarts on reload.
  const resolveDeadline = () => {
    const configured = timer.dataset.deadline;
    if (configured) {
      const parsed = new Date(configured);
      if (!isNaN(parsed)) return parsed;
    }
    const endOfDay = new Date();
    endOfDay.setHours(23, 59, 59, 999);
    return endOfDay;
  };

  let deadline = resolveDeadline();
  const isRolling = !timer.dataset.deadline;
  const pad = (n) => String(n).padStart(2, '0');

  const tick = () => {
    let remaining = deadline - Date.now();

    if (remaining <= 0) {
      if (isRolling) {
        // daily offer: roll to the next end-of-day rather than freezing at zero
        deadline = resolveDeadline();
        remaining = deadline - Date.now();
      } else {
        // a real deadline has passed - stop claiming time is left
        Object.values(fields).forEach((el) => el && (el.textContent = '00'));
        timer.hidden = true;
        clearInterval(handle);
        return;
      }
    }

    const totalSeconds = Math.floor(remaining / 1000);
    if (fields.days) fields.days.textContent = pad(Math.floor(totalSeconds / 86400));
    if (fields.hours) fields.hours.textContent = pad(Math.floor(totalSeconds / 3600) % 24);
    if (fields.minutes) fields.minutes.textContent = pad(Math.floor(totalSeconds / 60) % 60);
    if (fields.seconds) fields.seconds.textContent = pad(totalSeconds % 60);
  };

  tick();
  const handle = setInterval(tick, 1000);
});

/* Sticky offer bar: appears once the reader passes point 4,
   hides again when the real offer block is on screen so the two never overlap. */
(() => {
  const bar = document.querySelector('[data-sticky-cta]');
  const reasons = document.querySelectorAll('.soraya-listicle .lst-reason');
  const trigger = reasons[3]; // point 4
  const offer = document.querySelector('#lst-offer');
  if (!bar || !trigger) return;

  const update = () => {
    const passedPoint4 = trigger.getBoundingClientRect().bottom <= 0;
    const offerOnScreen = offer ? offer.getBoundingClientRect().top < window.innerHeight : false;
    const show = passedPoint4 && !offerOnScreen;
    if (bar.hidden === show) bar.hidden = !show;
  };

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();

  bar.addEventListener('click', (event) => {
    if (!offer) return;
    event.preventDefault();
    offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
